import { LoadingShimmer } from "@newsela/angelou";
import PropTypes from "prop-types";

import InlineImage from "@/view/ProseMirrorNode/ProseMirrorImageBlock/InlineImage";
import ZoomableImage from "@/view/ProseMirrorNode/ProseMirrorImageBlock/ZoomableImage";
import useViewportIsNotDesktop from "@/view/utils/useViewportIsNotDesktop";
import useZoomInOutImage from "@/view/utils/useZoomInOutImage";
import {
  loadingCss,
  figureCss,
  captionCss,
} from "./ProseMirrorImageBlock.style";

const propTypes = {
  additionalData: PropTypes.shape({
    data: PropTypes.array,
    error: PropTypes.object,
    loading: PropTypes.bool,
  }),
  currentFontSize: PropTypes.string,
  levelId: PropTypes.string,
  node: PropTypes.object,
};

const ProseMirrorImageBlock = ({
  additionalData,
  currentFontSize,
  levelId,
  node,
}) => {
  const { data, error, loading } = additionalData;
  const isMobile = useViewportIsNotDesktop();

  const image = data?.find((image) => node?.attrs?.contentId === image.id);
  const currentImage = image?.data ?? {};

  const { isImageExpanded, toggleZoom } = useZoomInOutImage(levelId, node);

  if (loading) {
    return (
      <div css={loadingCss}>
        <LoadingShimmer />
      </div>
    );
  }

  if (error || !currentImage?.url) return null;

  const zoomableProps = {
    currentImage,
    isImageExpanded,
    toggleZoom,
  };

  const renderInlineImage = () => {
    if (isMobile) {
      return <InlineImage currentImage={currentImage} />;
    } else {
      return <ZoomableImage {...zoomableProps} />;
    }
  };

  return (
    <figure css={figureCss(isImageExpanded)}>
      {renderInlineImage()}
      {node?.attrs?.bestCaption && (
        <figcaption css={captionCss(currentFontSize)}>
          {node?.attrs.bestCaption}
        </figcaption>
      )}
    </figure>
  );
};

ProseMirrorImageBlock.propTypes = propTypes;

export default ProseMirrorImageBlock;
